module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SitePage"
  }, [_c('p', [_vm._v("You can reach us at "), _c('a', {
    attrs: {
      "href": "mailto:info@ocds.co"
    }
  }, [_vm._v("info@ocds.co")]), _vm._v(".")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a133f40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/ContactPage.vue
// module id = 381
// module chunks = 1